var getDates = function(startDate, endDate) {
    var dates = [],
        currentDate = startDate,
        addDays = function(days) {
            var date = new Date(this.valueOf());
            date.setDate(date.getDate() + days);
            return date;
        };
    while (currentDate <= endDate) {
        currentDate.setHours(12);
        dates.push(currentDate.toString());
        currentDate = addDays.call(currentDate, 1);
    }
    return dates;
};

function YearMonthForm({ date, localeUtils, onChange, fromMonth, toMonth, enabledDays = None }) {
    const months = localeUtils.getMonths();
    const monthsToRender = [];
    let currentYear = date.getFullYear();

    let enabledMonths = [];
    let enabledYears = [];

    for (let month in months) {
        var dt = new Date(currentYear, month);
        // var c = new Date(toMonth.getTime());   
        // c.setDate(c.getDate()+1); 
        var inRange = dt >= fromMonth && dt < toMonth;
        if (inRange) {
            if (enabledDays && enabledDays.length != 0) {
                var nextMonth = new Date(dt.getFullYear(), dt.getMonth() + 1, dt.getDay());
                let dates = getDates(dt, nextMonth);
                for (var idx in dates) {
                    let date = dates[idx];
                    if (enabledDays.includes(date)) {
                        enabledMonths.push(months[month]);
                        break
                    }
                }
                
            }

            monthsToRender.push(months[month]);
        };
    };

    const years = [];
    for (let i = fromMonth.getFullYear(); i <= toMonth.getFullYear(); i += 1) {
        if (enabledDays && enabledDays.length != 0) {
            var iterYear = new Date(i, 0, 1);
            var nextYear = new Date(i + 1, 0, 1);

            let dates = getDates(iterYear, nextYear);
            for (var idx in dates) {
                let date = dates[idx];
                if (enabledDays.includes(date)) {
                    enabledYears.push(i);
                    break
                }
            }
            
        }

        years.push(i);
    }

    const handleChange = function handleChange(e) {
        const { year, month } = e.target.form;
        onChange(new Date(year.value, month.value));
    };

    return (
        <form className="DayPicker-Caption">
            <select name="month" onChange={handleChange} value={date.getMonth()}>
                {monthsToRender.map((month, i) => (
                    <option key={month} value={i} disabled={!enabledMonths.includes(month)}>
                        {month}
                    </option>
                ))}
            </select>
            <select name="year" onChange={handleChange} value={date.getFullYear()}>
                {years.map(year => (
                    <option key={year} value={year} disabled={!enabledYears.includes(year)}>
                        {year}
                    </option>
                ))}
            </select>
        </form>
    );
};

export default YearMonthForm;


// WEBPACK FOOTER //
// ./components/search/datePickers/utils.js